import { render, staticRenderFns } from "./ScreenCarouselPreview.vue?vue&type=template&id=24cc4430&scoped=true"
import script from "./ScreenCarouselPreview.vue?vue&type=script&lang=js"
export * from "./ScreenCarouselPreview.vue?vue&type=script&lang=js"
import style0 from "./ScreenCarouselPreview.vue?vue&type=style&index=0&id=24cc4430&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cc4430",
  null
  
)

export default component.exports